export default __webpack_public_path__ + "static/media/image-bottom.d5eb0905.PNG";